import { useSeriesCardContext } from './series-card'
import React from 'react'
import { Badge } from 'src/component/ui/badge/badge'
import { cn } from 'src/lib/utils'
import { stringUtil } from 'src/util/string-util'

interface SeriesCardMetaProps {
  className?: string
}

export const SeriesCardMeta = ({ className }: SeriesCardMetaProps): React.ReactElement => {
  const { series } = useSeriesCardContext()

  const seasons = series.duration?.seasons || 0
  const weeks = series.duration?.weeks || 0
  const classes = series.duration?.classes || 0

  return (
    <div className={cn('mt-2 flex flex-row gap-3', className)}>
      {seasons > 0 && (
        <Badge>
          {stringUtil.pluralizeIfNeeded({
            itemCount: seasons,
            singular: 'season',
          })}
        </Badge>
      )}
      {weeks > 0 && (
        <Badge>
          {stringUtil.pluralizeIfNeeded({
            itemCount: weeks,
            singular: 'week',
          })}
        </Badge>
      )}
      {classes > 0 && (
        <Badge>
          {stringUtil.pluralizeIfNeeded({
            itemCount: classes,
            singular: 'class',
            plural: 'classes',
          })}
        </Badge>
      )}
    </div>
  )
}
